import React from 'react';
import { motion } from "framer-motion";
import appdes1 from "../Images/app-des_1.png";
import appdes2 from "../Images/app-des_2.png";
import { useTranslation } from "react-i18next";

function AppDes() {
  const { t, i18n } = useTranslation();
  const isMobile = window.innerWidth < 768;
  return (
    <div className='appdes-sec-wrapping'>
      <div className='container'>

        {/* SECTION 1 */}
        <div className='row align-items-center appdes-row'>

          <motion.div
            className='col-md-6 appdes-img text-center order-2 order-md-1'
            initial={isMobile ? false : { opacity: 0, x: -40 }}
            whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <img src={appdes1} alt="Ride App UI" className='img-fluid' />
          </motion.div>

          <motion.div
            className='col-md-6 appdes-desc order-1 order-md-2'
            initial={isMobile ? false : { opacity: 0, x: 40 }}
            whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <button className='appdes-btn'>{t("app_sec1_btn")}</button>
            <h2 className='appdes-title text-white'>
              {t("app_sec1_title")}
            </h2>
            <p className='appdes-text'>
              {t("app_sec1_desc")}
            </p>
          </motion.div>

        </div>

        {/* SECTION 2 */}
        <div className='row align-items-center appdes-row flex-md-row-reverse'>

          <motion.div
            className='col-md-6 appdes-img text-center order-2 order-md-1'
            initial={isMobile ? false : { opacity: 0, x: 40 }}
             whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <img src={appdes2} alt="Ride App UI" className='img-fluid' />
          </motion.div>

          <motion.div
            className='col-md-6 appdes-desc order-1 order-md-2'
            initial={isMobile ? false : { opacity: 0, x: -40 }}
            whileInView={isMobile ? {} : { opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
          >
            <button className='appdes-btn'>{t("app_sec2_btn")}</button>
            <h2 className='appdes-title text-white'>
              {t("app_sec2_title")}
            </h2>
            <p className='appdes-text'>
              {t("app_sec2_desc")}
            </p>
          </motion.div>

        </div>

      </div>
    </div>
  );
}

export default AppDes;